/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Api } from '../../api';
import {
  errorToast,
  //informativeToast,
  useOutsideClick,
  // getFilterKey,
  // isSuperAdmin,
  // isCopanySuperAdmin,
  // contentApprovalStatusColors,
  // getPathForSurvey,
  successToast
} from '../../utils/helper';
import Table from '../../component/common/Table';
import React, { Fragment } from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import SearchInput from '../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import { PER_PAGE } from '../../utils/constants';
import { Transition, Dialog } from '@headlessui/react';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import CommonPopover from '../../component/common/popover';
import Loader from '../../component/common/Loader';
import Topbar2 from '../PulseSurvey/Topbar';
import Pagination from '../../component/common/Pagination/Pagination';
import DashboardInfoCard from '../../component/common/DashboardInfoCard';
import UpgradeDownArrow from '../../assets/images/upgrade-down-arrow.svg';
import { ShoorahTestB2BUsersPageData as pageData } from '../../utils/pageContent';

function B2BTestCompaniesTable({topbarShow=true}) {
  // const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  //const ref1 = useRef(null);
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  // const [showCalendar, setShowCalendar] = useState(false);
  const [startDate, setStartDate] = useState();
  const [allocatedNumberInput, setallocatedNumberInput] = useState('');
  const [allocatedNumberInputConfirm, setallocatedNumberInputConfirm] = useState('');
  const [numberError, setNumberError] = useState('');
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('desc');
  const [sortBy, setSortBy] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const cancelButtonRef = useRef(null);
  const [openApproveDialoge, setopenApproveDialoge] = useState(false);
  const [orderTypeis0, setorderTypeis0] = useState(0);

  const [totalCompaniesInsights, settotalCompaniesInsights] = useState(0);
  const [totalEmployees, settotalEmployees] = useState(0);
  const [totalSelfTakenTests, settotalSelfTakenTests] = useState(0);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [companyIDwhoesSupportNumberHasToBeDone, setcompanyIDwhoesSupportNumberHasToBeDone] =
    useState('');

  const [filterCriteria, setFilterCriteria] = useState({
    companySubscription: ''
  });

  const redirectUrl = '/test/b2b'; // this is the URL for the edit page
  const columns = [
    // {
    //   title: '',
    //   key: 'profile',
    //   sortable: false,
    //   type: 'profile-without-name',
    //   align: 'left',
    //   width: 250,
    //   style: {
    //     opacity: 'opacity-100'
    //   }
    // },
    {
      title: pageData.tableHeaderText.company,
      key: 'company_name',
      sortable: false,
      type: 'text',
      align: 'left',
      rowClassName: '!text-base font-medium'
    },

    {
      title: pageData.tableHeaderText.selfTakenTest,
      key: 'self_test_users_count',
      sortable: false,
      type: 'text-without-black-hover',
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.otherTaken,
      key: 'test_count',
      sortable: false,
      sortKey: 'test_count',
      type: 'text',
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.reTakenTest,
      key: 'repeated_tests_count',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'text',
      align: 'left'
    }
  ];

  const handlePagination = (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    searchKey,
    createdAt = ''
    // startDate = '',
    // endDate = ''
  ) => {
    setLoader(true);

    if (sortByKey === '') sortByKey = 'name';
    if (orderByKey === '') orderByKey = 'desc';

    Api.getTestB2BCompaniesList(
      pageNumber,
      pageSize
      //   sortByKey,
      //   orderByKey,
      //   searchKey,
      //   createdAt,
      //startDate, // this key we use for calandar aka formattedDate
      //endDate
    )
      .then((response) => {
        setLoader(false);
        console.log('Data from B2B Companies API call', response?.data?.data?.data);

        if (response?.data) {
          if (response?.data?.data) {
            setUsersList(
              response?.data?.data?.data?.map(({ email, companyImage, companyTitle, ...rest }) => ({
                ...rest,
                companyEmail: email,
                profile: companyImage,
                name: companyTitle,
                nameBesideImage: false
              }))
            );

            setCurrentPage(pageNumber);
            setTotalCount(response?.data?.data?.pagination?.totalCount);
            setLoader(false);
          } else {
            setLoader(false);
          }
        } else if (response?.data?.meta?.code === 401) {
          errorToast(response?.message);
          setLoader(false);
          errorToast(pageData.somethingWentWrongErrorMessage);
        } else if (response?.data?.meta?.code === 0) {
          setLoader(false);
          setCurrentPage(1);
          setUsersList([]);
          setTotalCount(0);
          errorToast(response?.data?.meta?.message);
          errorToast(pageData.somethingWentWrongErrorMessage);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log('error we got after the Get Companies API call', error);
      })
      .finally(() => {
        setLoader(false);
      });

    // API CALL FOR THE B2B COMPANIES INSIGHTS
    Api.getTestResultsOverviews('b2b')
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          settotalCompaniesInsights(response?.data?.data?.summary?.total_companies);
          settotalEmployees(response?.data?.data?.summary?.total_company_users);
          settotalSelfTakenTests(response?.data?.data?.summary?.total_self_tests);
        }
      })
      .catch((error) => {
        console.log('error we got after the status change API call', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, searchTerm);
    return () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, []);

  // This handlePerPage is not being used in this table
  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, sortBy, sortOrder, searchTerm);
  };

  const refreshTable = () => handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, '');

  const resetHandler = () => {
    setFilterCriteria({
      companySubscription: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, sortBy, sortOrder, '');
  };

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    handlePagination(1, selectedPerPage.value, sortBy, sortOrder, searchTerm, formattedDate);
    setIsOpen2(false);
  };

  // useRef to handle click outside the Date range calandar
  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const deleteHandler = (_id) => {};

  const rowsData = usersList.map((item) => {
    return {
      ...item,
      test_count: <>{item.test_count - item.self_test_users_count}</>,
      company_name: (
        <>
          <div>
            {item.company_name
              ? item.company_name
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ')
              : ''}
          </div>
        </>
      ),
      isActive: (
        <>
          <div
            className={`w-24 h-6 flex items-center justify-center text-center text-xs rounded-full border appearance-none
                ${
                  item?.isActive
                    ? 'bg-[#DDF2BF] text-[#438038] border-[#438038]'
                    : 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]'
                }`}
          >
            {item?.isActive ? pageData.activetext : pageData.inActiveText}
          </div>
        </>
      ),
      repeated_tests_count: (
        <>
          <div className="flex items-center justify-between ">
            <div className="ml-[15%]">{item.repeated_tests_count}</div>

            <button
              onClick={() => {
                // console.log('Company data', item);
                // setShowCompanyInfo(true);
                // setCompanyInfoObject(item);
                navigate(`/test/b2b/b2b-company?companyid=${item._id}`);
              }}
              className="mr-[20%]"
            >
              {selectedTheme ? (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_520_11514)">
                      <path
                        d="M4.8165 1.63306C7.67052 3.06006 9.24519 4.48707 10.6875 7.06105C11.014 7.64381 11.014 8.35603 10.6875 8.93878C9.24519 11.5127 7.67052 12.9397 4.8165 14.3668"
                        stroke="#F3F4F6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_520_11514">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(16) rotate(90)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </>
              ) : (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_520_11514)">
                      <path
                        d="M4.8165 1.63306C7.67052 3.06006 9.24519 4.48707 10.6875 7.06105C11.014 7.64381 11.014 8.35603 10.6875 8.93878C9.24519 11.5127 7.67052 12.9397 4.8165 14.3668"
                        stroke="#313B6B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_520_11514">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(16) rotate(90)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </>
              )}
            </button>
          </div>
        </>
      )
    };
  });

  const subAdminStatusCards = [
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.7961 27.7097C41.4361 26.2591 40.6161 24.9607 39.4548 24.0114C38.2164 22.9994 36.6663 22.4465 35.0672 22.4465C33.4679 22.4465 31.9178 22.9994 30.6796 24.0114C30.4099 24.2318 30.1587 24.4711 29.9273 24.7266C31.358 24.9862 32.748 25.6024 33.8809 26.7353C34.3083 27.1627 34.6622 27.6267 34.9511 28.1157C37.2245 28.1205 39.4972 27.9852 41.7961 27.7097Z"
            fill="#B6C0F3"
          />
          <path
            d="M32.5938 38.0958C33.7551 39.0451 34.5753 40.3436 34.9352 41.7941C34.9352 41.7941 30.8665 42.3245 28.2063 42.3245C25.546 42.3245 21.4774 41.7941 21.4774 41.7941C21.8373 40.3436 22.6574 39.0451 23.8187 38.0958C25.057 37.0839 26.607 36.5309 28.2063 36.5309C29.8055 36.5309 31.3556 37.0839 32.5938 38.0958Z"
            fill="#B6C0F3"
          />
          <path
            d="M28.2045 36.5303C30.8418 36.5303 32.3253 35.0468 32.3253 32.4095C32.3253 29.7722 30.8418 28.2887 28.2045 28.2887C25.5671 28.2887 24.0836 29.7722 24.0836 32.4095C24.0836 35.0468 25.5671 36.5303 28.2045 36.5303Z"
            fill="#B6C0F3"
          />
          <path
            d="M34.9352 41.7941C34.5753 40.3436 33.7551 39.0451 32.5938 38.0958C31.3556 37.0837 29.8055 36.5309 28.2063 36.5309C26.607 36.5309 25.057 37.0837 23.8187 38.0958C22.6574 39.0451 21.8373 40.3436 21.4774 41.7941"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.2045 36.5303C30.8418 36.5303 32.3253 35.0468 32.3253 32.4095C32.3253 29.7722 30.8418 28.2887 28.2045 28.2887C25.5671 28.2887 24.0836 29.7722 24.0836 32.4095C24.0836 35.0468 25.5671 36.5303 28.2045 36.5303Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.0671 22.446C37.7044 22.446 39.1879 20.9625 39.1879 18.3252C39.1879 15.6878 37.7044 14.2043 35.0671 14.2043C32.4296 14.2043 30.9461 15.6878 30.9461 18.3252C30.9461 20.9625 32.4296 22.446 35.0671 22.446Z"
            fill="#B6C0F3"
          />
          <path
            d="M35.0671 22.446C37.7044 22.446 39.1879 20.9625 39.1879 18.3252C39.1879 15.6878 37.7044 14.2043 35.0671 14.2043C32.4296 14.2043 30.9461 15.6878 30.9461 18.3252C30.9461 20.9625 32.4296 22.446 35.0671 22.446Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M41.7937 27.7097C41.4338 26.2591 40.6138 24.9607 39.4524 24.0114C38.2143 22.9994 36.6642 22.4465 35.0648 22.4465C33.4657 22.4465 31.9156 22.9994 30.6773 24.0114"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.2055 27.7097C14.5654 26.2591 15.3855 24.9607 16.5468 24.0114C17.7851 22.9994 19.3351 22.4465 20.9344 22.4465C22.5336 22.4465 24.0837 22.9994 25.3219 24.0114C25.5916 24.2318 25.8428 24.4711 26.0742 24.7266C24.6435 24.9862 23.2535 25.6024 22.1206 26.7353C21.6932 27.1627 21.3394 27.6267 21.0504 28.1157C18.7771 28.1205 16.5043 27.9852 14.2055 27.7097Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9357 22.446C18.2983 22.446 16.8148 20.9625 16.8148 18.3252C16.8148 15.6878 18.2983 14.2043 20.9357 14.2043C23.5731 14.2043 25.0566 15.6878 25.0566 18.3252C25.0566 20.9625 23.5731 22.446 20.9357 22.446Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9357 22.446C18.2983 22.446 16.8148 20.9625 16.8148 18.3252C16.8148 15.6878 18.2983 14.2043 20.9357 14.2043C23.5731 14.2043 25.0566 15.6878 25.0566 18.3252C25.0566 20.9625 23.5731 22.446 20.9357 22.446Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.2055 27.7097C14.5654 26.2591 15.3855 24.9607 16.5468 24.0114C17.7851 22.9994 19.3351 22.4465 20.9344 22.4465C22.5336 22.4465 24.0837 22.9994 25.3219 24.0114"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={pageData.totalCompaniesTitle}
      value={totalCompaniesInsights}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.0514 34.8548C38.4791 36.4192 38.2439 37.9659 37.6293 39.2467C37.5595 39.3923 37.4848 39.5351 37.4052 39.6745H38.2662C41.3832 39.6745 43.135 36.3421 40.5407 34.6144C39.4993 33.9208 38.3643 33.3567 37.1586 32.9451C37.5553 33.5185 37.8607 34.1575 38.0514 34.8548Z"
            fill="#E5EAF9"
          />
          <path
            d="M37.405 39.6741H38.2652C41.3819 39.6741 43.1337 36.3417 40.5396 34.6139C39.4984 33.9206 38.3638 33.3567 37.1586 32.9451"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.5836 28.6211C33.2119 26.7979 33.8497 24.4451 33.8497 22.0715C33.8497 20.818 33.6719 19.5703 33.2641 18.4033C33.3029 18.4028 33.3419 18.4025 33.381 18.4025C36.7197 18.4025 38.5977 20.2805 38.5977 23.6192C38.5977 26.9579 36.7197 28.8359 33.381 28.8359C32.7243 28.8359 32.1241 28.7632 31.5836 28.6211Z"
            fill="#E5EAF9"
          />
          <path
            d="M31.5836 28.6213C32.1239 28.7633 32.7238 28.8359 33.3802 28.8359C36.7188 28.8359 38.5969 26.9579 38.5969 23.6192C38.5969 20.2805 36.7188 18.4025 33.3802 18.4025C33.3413 18.4025 33.3026 18.4028 33.2641 18.4033"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M33.1794 34.1911C35.9905 36.0635 34.0923 39.6743 30.7148 39.6743H18.0312C14.6537 39.6743 12.7555 36.0635 15.5666 34.1911C18.0881 32.5117 21.1163 31.533 24.373 31.533C27.6298 31.533 30.6579 32.5117 33.1794 34.1911Z"
            fill="#B6C0F3"
          />
          <path
            d="M24.3773 27.8185C28.0553 27.8185 30.1241 25.7496 30.1241 22.0717C30.1241 18.3937 28.0553 16.3248 24.3773 16.3248C20.6993 16.3248 18.6305 18.3937 18.6305 22.0717C18.6305 25.7496 20.6993 27.8185 24.3773 27.8185Z"
            fill="#B6C0F3"
          />
          <path
            d="M33.1794 34.1911C35.9905 36.0635 34.0923 39.6743 30.7148 39.6743H18.0312C14.6537 39.6743 12.7555 36.0635 15.5666 34.1911C18.0881 32.5117 21.1163 31.533 24.373 31.533C27.6298 31.533 30.6579 32.5117 33.1794 34.1911Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.3773 27.8185C28.0553 27.8185 30.1241 25.7496 30.1241 22.0717C30.1241 18.3937 28.0553 16.3248 24.3773 16.3248C20.6993 16.3248 18.6305 18.3937 18.6305 22.0717C18.6305 25.7496 20.6993 27.8185 24.3773 27.8185Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={pageData.totalEmployeesTitle}
      value={totalEmployees}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />

          <g transform="translate(12, 12)">
            <path
              d="M20.8032 10.5885C20.1368 7.88295 19.083 5.58615 17.4867 3.48033C16.7335 2.48682 15.2719 2.48683 14.5182 3.47995C12.9201 5.58587 11.8624 7.88278 11.1959 10.5885C8.48555 10.4916 5.9897 10.8028 3.51527 11.6049C2.3113 11.9951 1.8217 13.4092 2.53811 14.4562C4.0226 16.6258 5.85543 18.3312 8.22523 19.7687C7.3063 22.2867 6.86818 24.7471 6.84182 27.3297C6.82854 28.6311 8.05042 29.5617 9.28827 29.1752C11.755 28.4053 13.9209 27.2047 15.9966 25.4423C18.0725 27.2049 20.2421 28.4055 22.7109 29.1754C23.9488 29.5617 25.1706 28.6311 25.1572 27.3297C25.1309 24.7471 24.6929 22.2867 23.7739 19.7687C26.1437 18.3312 27.9765 16.6258 29.461 14.4562C30.1775 13.4092 29.6879 11.9951 28.4839 11.6049C26.0095 10.8028 23.5135 10.4916 20.8032 10.5885Z"
              fill="#B6C0F3"
            />
            <path
              d="M20.8032 10.5885C20.1368 7.88295 19.083 5.58615 17.4867 3.48033C16.7335 2.48682 15.2719 2.48683 14.5182 3.47995C12.9201 5.58587 11.8624 7.88278 11.1959 10.5885C8.48555 10.4916 5.9897 10.8028 3.51527 11.6049C2.3113 11.9951 1.8217 13.4092 2.53811 14.4562C4.0226 16.6258 5.85543 18.3312 8.22523 19.7687C7.30631 22.2867 6.86818 24.7471 6.84182 27.3297C6.82854 28.6311 8.05042 29.5617 9.28827 29.1752C11.755 28.4053 13.9209 27.2047 15.9966 25.4423C18.0725 27.2049 20.2421 28.4055 22.7109 29.1754C23.9488 29.5617 25.1706 28.6311 25.1572 27.3297C25.1309 24.7471 24.6929 22.2867 23.7739 19.7687C26.1437 18.3312 27.9765 16.6258 29.461 14.4562C30.1775 13.4092 29.6879 11.9951 28.4839 11.6049C26.0095 10.8028 23.5135 10.4916 20.8032 10.5885Z"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M16.0008 21.0395L16.0008 15.1004C16.0008 14.1632 15.2411 13.4035 14.3039 13.4035H13.4554M16.0008 21.0395L18.5471 21.0394M16.0008 21.0395L13.4565 21.0394"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </svg>
      }
      title={pageData.selfTakenTestTitle}
      value={totalSelfTakenTests}
    />
  ];

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageData.metaTitle}</title>
        </Helmet>
        {loader ? <Loader /> : null}
        {topbarShow === true &&
        <Topbar2 title={pageData.pageTitle} infoBtn={true} />}
      </div>

      <div className="relative lg:pl-5 lg:mb-[45px]">
        {/*search options, Date filter & Add Company are here */}
        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3">
          {/* Left-aligned search input */}
          <div className="flex items-center justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // Debouncing search input
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                  handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, e.target.value);
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder={pageData.searchPlaceholder}
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* CALANDER IS COMMENTED HERE CUZ ITS NOT IN THE FIGMA UI */}
          {/* <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div ref={ref2} 
              className="relative inline-block text-left w-full md:w-auto mb-2 md:mb-0"
              >
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full md:w-auto px-5 py-2 text-xs md:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate ? `${new Date(startDate).toLocaleDateString()}` : 'Date Created'}
                </span>
                {selectedTheme ? (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#F3F4F6"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                ) : (   
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#0B1D2E"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-96 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            
          </div> */}
        </div>

        <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
          {subAdminStatusCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        <div className="mt-2 flex flex-col">
          <div className="mt-4 w-full md:w-[100%]">
            <Table
              columns={columns}
              data={rowsData}
              addNewURL={redirectUrl}
              name={'company_table'}
              setDeleteId={deleteHandler}
              bottomBorder={totalCount > selectedPerPage?.value}
              refreshTable={refreshTable}
              loader={loader}
            />
          </div>
        </div>

        <div>
          {usersList.length > 0 && !loader ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={selectedPerPage?.value}
              onPageChange={(page) => {
                handlePagination(page, selectedPerPage?.value, sortBy, sortOrder, searchTerm);
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default B2BTestCompaniesTable;
